import React from 'react';
interface FormFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className'> {
  id: string;
  label: string;
  error?: string;
  optional?: boolean;
  className?: string;
  icon?: React.ReactNode;
}
export function FormField({
  id,
  label,
  error,
  optional,
  className = '',
  icon,
  ...inputProps
}: FormFieldProps) {
  const errorId = `${id}-error`;
  return <div className={className} data-id="element-136" data-mp="zgudny86xw6n">
      <label htmlFor={id} className="mb-1.5 flex items-baseline justify-between text-sm" data-id="element-137" data-mp="zfst935abxc9">
        <span data-id="element-138" data-mp="14f5p2de4weqz">{label}</span>
        {optional && <span className="text-xs text-muted" data-id="element-139" data-mp="14e44nib8afwl">Facultatif</span>}
      </label>
      <div className="relative" data-id="element-140" data-mp="18itx0x6ohccr">
        <input id={id} aria-invalid={error ? true : undefined} aria-describedby={error ? errorId : undefined} className={`h-12 w-full rounded-md border bg-card px-4 text-sm outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-muted/60 focus:border-ink focus:ring-2 focus:ring-ink/10 ${error ? 'border-clay' : 'border-line'} ${icon ? 'pr-11' : ''}`} {...inputProps} data-id="element-141" data-mp="18ffyk014xnal" />
        {icon && <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-muted" data-id="element-142" data-mp="l44b4d64ssyi">{icon}</span>}
      </div>
      {error && <p id={errorId} className="mt-1.5 text-xs text-clay" data-id="element-143" data-mp="c593qxrcpctm">
          {error}
        </p>}
    </div>;
}